import { useProducts } from "@/common/hooks/queries/useProducts";
import useDebounce from "@/common/hooks/useDebounce";
import { Mapper } from "@/common/services/mapper";
import { ProductData } from "@/common/types/product.type";
import { DashboardFilterProps, DashboardFilters } from "@/features/company/types/dashboards/dashboard.type";
import DashboardFilterBadge from "../DashboardFilterBadge";

const DashboardFilterProductBadge = ({ filters, setFilters }: DashboardFilterProps) => {
  const [search, setSearch] = useDebounce('');

  const {
    data: productsOptions,
  } = useProducts({
    filters: {
      search,
    },
    mapper: Mapper.mapToOptions<ProductData>({
      labelFieldName: 'display_name',
      valueFieldName: 'id',
    }),
  });

  return (
    <DashboardFilterBadge
      filterKey={DashboardFilters.Product}
      options={productsOptions}
      filters={filters}
      setFilters={setFilters}
      setSearch={setSearch}
    />
  );
}

export default DashboardFilterProductBadge;
